'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initRouter = exports.navigateBack = exports.navigateTo = undefined;

var _actionTypes = require('../constants/actionTypes');

var types = _interopRequireWildcard(_actionTypes);

var _router = require('../utils/router');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

var navigateTo = exports.navigateTo = function navigateTo(route) {
  var shouldPushState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : types.CHANGE_ROUTE;

  if (shouldPushState) {
    (0, _router.pushState)(route);
  }

  return {
    type: type,
    route: route
  };
};

var navigateBack = exports.navigateBack = function navigateBack(event) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : types.CHANGE_ROUTE;
  return function (dispatch) {
    var state = event.state;

    if (!state) {
      return false;
    }

    dispatch(navigateTo(state.route, false, type));
  };
};

var initRouter = exports.initRouter = function initRouter(paths) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : types.CHANGE_ROUTE;
  return function (dispatch) {
    window.onpopstate = function (e) {
      return dispatch(navigateBack(e));
    };

    var hash = location.hash ? location.hash.slice(2) : '';
    var route = (0, _router.parseRoute)(hash, paths);
    dispatch(navigateTo(route, false, type));
  };
};